import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { Loader } from '@jutro/components';
// eslint-disable-next-line import/no-unresolved
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslator } from '@jutro/locale';
import { withRouter } from 'react-router-dom';
import { PolicyService } from 'gw-capability-gateway';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import messages from './PolicyRenewalSummary.messages';
import metadata from './PolicyRenewalSummary.metadata.json5';
import styles from './PolicyRenewalSummary.module.scss';
import PolicySummary from '../TFPAPolicySummary/PolicySummary';

import { Link } from '@jutro/router';

// US26353
function PolicyRenewalSummary(props) {
    
    const [jobObject,setJobObject] = useState({});
    const { authHeader } = useAuthentication();
    const [renewalJobObject,setRenewalJobObject] = useState();  
    const [currentJobObject,setCurrentJobObject] = useState();  
    const [onTabChangeObj,setOnTabChangeObj] = useState();
    const [cuurentActiveTab,setActiveTab] = useState("renewalTab");
    const [loader,setLoader] = useState(false);
    
    const getJobDetails = useCallback(() => {
        setLoader(true);
        PolicyService.getPolicyJobDetails(props.match.params.jobNumber, authHeader)
            .then((response) => {

                // DE18523
                const latestRenewal = _.chain(response).filter(pd => pd.jobType === 'Renewal')
                .reverse(pd => pd.latestJobPolicyPeriod.effective).value()[0]
 
                setJobObject(response);
                setRenewalJobObject(latestRenewal);
                setCurrentJobObject(response[0]);
                setOnTabChangeObj(latestRenewal);
                setLoader(false);
            });
            
    }, [authHeader, props]);
    
    const getRenewalTabHeading = useCallback(() => {
        
        if (renewalJobObject) {
            return <span>Renewal{`(${renewalJobObject.jobStatus})`}</span>;
        }

        return <span>Renewal</span>;
    }, [renewalJobObject]);
    
    const onTabChange = useCallback((item) => {
       
        if (item === 'renewalTab') {
            setOnTabChangeObj(renewalJobObject);          
        } else {
            setOnTabChangeObj(currentJobObject);
        }

        setActiveTab(item)
    }, [currentJobObject, renewalJobObject]);

    const getPolicySummaryTitle = useCallback(()=>{
        if(onTabChangeObj){
            return <span>Policy Details {`${onTabChangeObj.latestJobPolicyPeriod.policyNumber}`}</span>
        }
       
    },[onTabChangeObj])

    const quotePrintDocument = useCallback(() => {
        window.print();
    }, []);
    
    const getBackToPreviousState = useCallback(() => {
        props.history.goBack();
    }, [props]);


    useEffect(() => {
       
        getJobDetails();
    }, [getJobDetails]);
    
   
    const overrideProps = {
        renewalTab:{
            heading:getRenewalTabHeading(),
        },
        policyJobSummaryTab:{
            activeTab: cuurentActiveTab,
        },
        policySummarySection:{
            onTabChangeObj,
            jobNumber:props.match.params.jobNumber
        },
        policyRenewalSummaryTitle:{
            content:getPolicySummaryTitle()
        }
    };

    

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onTabChange,
            getRenewalTabHeading,
            quotePrintDocument,
            getBackToPreviousState
        },
        resolveComponentMap: {
            policySummaryComponent : PolicySummary
        }
    };

    return (
        <Loader loaded={!loader} >
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={jobObject}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
        </Loader>
    );
}

PolicyRenewalSummary.propTypes = wizardProps;
export default withRouter(PolicyRenewalSummary);
